import React from 'react'
import PropTypes from 'prop-types'
import { IconSLI60Wrapper } from './IconSLI60Wrapper'

export const Icon60UserCircle = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLI60Wrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 48 48'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M24.000,47.999 C10.767,47.999 0.000,37.233 0.000,24.000 C0.000,10.766 10.767,0.000 24.000,0.000 C37.233,0.000 48.000,10.766 48.000,24.000 C48.000,37.233 37.233,47.999 24.000,47.999 ZM37.949,40.997 C35.446,35.601 29.909,31.999 24.018,31.999 C18.120,31.999 12.577,35.610 10.077,41.017 C13.873,44.128 18.721,45.999 24.000,45.999 C29.291,45.999 34.150,44.121 37.949,40.997 ZM24.115,29.000 C29.014,29.000 33.000,24.962 33.000,19.999 C33.000,15.037 29.014,11.000 24.115,11.000 C19.216,11.000 15.231,15.037 15.231,19.999 C15.231,24.962 19.216,29.000 24.115,29.000 ZM24.000,2.000 C11.869,2.000 2.000,11.869 2.000,24.000 C2.000,30.103 4.501,35.630 8.529,39.619 C10.931,34.882 15.440,31.467 20.539,30.377 C16.291,28.877 13.231,24.798 13.231,19.999 C13.231,13.934 18.113,9.000 24.115,9.000 C30.117,9.000 35.000,13.934 35.000,19.999 C35.000,24.823 31.908,28.922 27.625,30.402 C32.664,31.519 37.112,34.910 39.496,39.597 C43.510,35.609 46.000,30.091 46.000,24.000 C46.000,11.869 36.131,2.000 24.000,2.000 Z'
        />
      </svg>
    </IconSLI60Wrapper>
  )
}

Icon60UserCircle.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
